/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProdottoDTO
 */
export interface ProdottoDTO {
    /**
     * 
     * @type {string}
     * @memberof ProdottoDTO
     */
    padreCodice?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProdottoDTO
     */
    padreDescrizione?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProdottoDTO
     */
    codice?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProdottoDTO
     */
    descrizione?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProdottoDTO
     */
    prezzoVendita?: number;
    /**
     * 
     * @type {number}
     * @memberof ProdottoDTO
     */
    sampleOmaggioNumero?: number;
    /**
     * 
     * @type {number}
     * @memberof ProdottoDTO
     */
    shopperOmaggioNumero?: number;
    /**
     * 
     * @type {number}
     * @memberof ProdottoDTO
     */
    mouiletteOmaggioNumero?: number;
    /**
     * 
     * @type {string}
     * @memberof ProdottoDTO
     */
    imageUrl?: string | null;
}

/**
 * Check if a given object implements the ProdottoDTO interface.
 */
export function instanceOfProdottoDTO(value: object): value is ProdottoDTO {
    return true;
}

export function ProdottoDTOFromJSON(json: any): ProdottoDTO {
    return ProdottoDTOFromJSONTyped(json, false);
}

export function ProdottoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProdottoDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'padreCodice': json['padreCodice'] == null ? undefined : json['padreCodice'],
        'padreDescrizione': json['padreDescrizione'] == null ? undefined : json['padreDescrizione'],
        'codice': json['codice'] == null ? undefined : json['codice'],
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
        'prezzoVendita': json['prezzoVendita'] == null ? undefined : json['prezzoVendita'],
        'sampleOmaggioNumero': json['sampleOmaggioNumero'] == null ? undefined : json['sampleOmaggioNumero'],
        'shopperOmaggioNumero': json['shopperOmaggioNumero'] == null ? undefined : json['shopperOmaggioNumero'],
        'mouiletteOmaggioNumero': json['mouiletteOmaggioNumero'] == null ? undefined : json['mouiletteOmaggioNumero'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
    };
}

  export function ProdottoDTOToJSON(json: any): ProdottoDTO {
      return ProdottoDTOToJSONTyped(json, false);
  }

  export function ProdottoDTOToJSONTyped(value?: ProdottoDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'padreCodice': value['padreCodice'],
        'padreDescrizione': value['padreDescrizione'],
        'codice': value['codice'],
        'descrizione': value['descrizione'],
        'prezzoVendita': value['prezzoVendita'],
        'sampleOmaggioNumero': value['sampleOmaggioNumero'],
        'shopperOmaggioNumero': value['shopperOmaggioNumero'],
        'mouiletteOmaggioNumero': value['mouiletteOmaggioNumero'],
        'imageUrl': value['imageUrl'],
    };
}

